/**
 * Campaign fields script
 */
import utils from '../utils';
import Vue from 'vue/dist/vue';
import draggable from 'vuedraggable/dist/vuedraggable';
import ui from '../ui';

require('./vue/select2');
require('./vue/summernote');

/**
 * Add a field to a step
 * @param {int} step
 */
const addField = function(step) {
    let selectedFieldId = this.field_selection[step];
    let selectedField = null;
    this.fields.forEach(function(v) {
        if (v.id === parseInt(selectedFieldId)) {
            selectedField = v;
        }
    });
    this.steps[step].push({
        id:               null,
        field_id:         selectedField.id,
        field:            {name: selectedField.text, type: selectedField.type, settings: selectedField.settings},
        status:           'published',
        validation_rules: {_ids: []},
        width:            '100%',
        hide_on:          [
            {
                field:  null,
                values: []
            }
        ]
    });
};

/**
 * Get hide on options
 *
 * Returns fields with a lower index than the field for which these options are requested
 *
 * @param {int} stepIndex
 * @param {int} fieldIndex
 * @returns {Array}
 */
const getHideOnOptions = function(stepIndex, fieldIndex) {
    // Get fields before the current field
    let options = [];
    let i;
    for (i = stepIndex; i >= 0; i--) {
        let step = this.steps[i];
        let count = i === stepIndex ? (fieldIndex - 1) : (step.length - 1);
        let j;
        for (j = count; j >= 0; j--) {
            let field = step[j];
            if (field.field_id && this.allowedHideOnTypes.indexOf(field.field.type) !== -1) {
                options.push({id: getFieldFormIndex(i, j), text: field.field.name});
            }
        }
    }

    return options;
};

/**
 * Get possible field values
 *
 * @param {int} fieldFormIndex
 * @returns {Array}
 */
const getPossibleFieldValues = function(fieldFormIndex) {
    let stepAndField = getStepAndFieldIndex(fieldFormIndex);
    let step = this.steps[stepAndField[0]];
    let field = step[stepAndField[1]];
    if (field.field.settings.options) {
        let options = [];
        for (let i in field.field.settings.options) {
            let option = field.field.settings.options[i];
            options.push({id: option.value, text: option.label});
        }
        return options;
    }
    return [];
};

/**
 * Get hide on options
 *
 * Returns custom defined width options
 *
 * @returns {Array}
 */
const getWidthOptions = function() {
    return ['100', '80', '60', '50', '40', '20'];
};

/**
 * Add content to a step
 * @param {int} step
 */
const addContent = function(step) {
    this.steps[step].push({
        id:           null,
        content_text: ' ',
        status:       'published',
    });
};

/**
 * Get the form index for a field
 * @param {int} stepIndex
 * @param {int} fieldIndex
 */
const getFieldFormIndex = function(stepIndex, fieldIndex) {
    return 1000 * stepIndex + fieldIndex;
};

/**
 * Get step and field index
 * @param {int} fieldFormIndex
 * @returns {*[]}
 */
const getStepAndFieldIndex = function(fieldFormIndex) {
    if (fieldFormIndex < 1000) {
        return [0, fieldFormIndex];
    }
    return [Math.floor(fieldFormIndex / 1000), fieldFormIndex % 1000];
};

/**
 * Update indices of related fields
 *
 * @param {int}      oldIndex
 * @param {int|null} newIndex
 * @param {int}      stepIndex
 */
const updateRelatedFieldIndices = function(oldIndex, newIndex, stepIndex) {
    let oldFieldFormIndex = getFieldFormIndex(stepIndex, oldIndex);
    var newFieldFormIndex = getFieldFormIndex(stepIndex, newIndex);

    // Nothing was moved
    if (oldFieldFormIndex === newFieldFormIndex) {
        return;
    }
    let getModifier;
    if (newIndex === null || newIndex === -1) {
        // Item was removed
        getModifier = function(fieldFormIndex) {
            return fieldFormIndex >= oldFieldFormIndex ? -1 : 0;
        };
    } else if (newIndex > oldIndex) {
        // Item was moved down
        getModifier = function(fieldFormIndex) {
            return fieldFormIndex >= oldFieldFormIndex && fieldFormIndex <= newFieldFormIndex ? -1 : 0;
        };
    } else {
        // Item was moved up
        getModifier = function(fieldFormIndex) {
            return fieldFormIndex >= newFieldFormIndex && fieldFormIndex <= oldFieldFormIndex ? 1 : 0;
        };
    }
    let i;
    for (i = 0; i < this.steps.length; i++) {
        let step = this.steps[i];
        let j;
        for (j = 0; j < step.length; j++) {
            let field = step[j];
            if (field.hide_on[0].field !== null) {
                let fieldFormIndex = parseInt(field.hide_on[0].field);
                // Special case for when the hide_on field itself was moved
                if (fieldFormIndex === oldFieldFormIndex) {
                    field.hide_on[0].field = newFieldFormIndex;
                } else {
                    // Adjust the field form index of the related field
                    let modifier = getModifier(fieldFormIndex);
                    field.hide_on[0].field = fieldFormIndex + modifier;
                }
            }
        }
    }
};

/**
 * Initialization of VM for all campaign fields related script
 * inside a container
 * @param {jQuery} $container
 */
const initializeContainer = function($container) {
    $container.find('[data-campaign-fields-editor]').each(function() {
        let $editor = $(this);
        if ($editor.hasClass('initialized')) {
            return;
        }

        let id = utils.uniqueID($editor);

        // Update the template to bind
        utils.vueBind($editor.find('[id], [name], [for]'), ['id', 'name', 'for']);

        let vm = new Vue({
            el:         `#${id}`,
            data:       $(this).data('campaign-fields-editor'),
            components: {
                draggable: draggable,
            },
            methods:    {
                addField:                  addField,
                addContent:                addContent,
                getFieldFormIndex:         getFieldFormIndex,
                getHideOnOptions:          getHideOnOptions,
                getWidthOptions:           getWidthOptions,
                getPossibleFieldValues:    getPossibleFieldValues,
                updateRelatedFieldIndices: updateRelatedFieldIndices,
                removeField:               function(stepIndex, fieldIndex) {
                    this.steps[stepIndex].splice(fieldIndex, 1);
                    this.updateRelatedFieldIndices(fieldIndex, null, stepIndex);
                },
                afterDrag:                 function(event, stepIndex) {
                    let $element = $(this.$el);
                    this.updateRelatedFieldIndices(event.oldIndex, event.newIndex, stepIndex);
                    // Trigger changes on all selects as select2 component
                    // does not register this automatically and values will look 'undragged'
                    $element.find('select').trigger('change');
                }
            },
            updated:    function() {
                let $element = $(this.$el);
                let vm = this;
                ui.initializeContainer($element);
                $element.find('select').on('change', function() {
                    vm.$emit('input', this.value);
                });
            },
        });

        $editor.addClass('initialized').data('vm', vm);
    });
};

// Export initialization
export default {
    initializeContainer: initializeContainer,
};



// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/components/campaign_fields.js